import { getPagePath, trans } from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';

import Dropdown from '../Dropdown';

import DropdownItem from '../DropdownItem';

import { DSIcon } from '../../../base';

import SupportCenter from '../SupportCenter';

import DropdownSeparator from '../DropdownSeparator/DropdownSeparator';

import HeaderLink from '../HeaderContainer/HeaderLink';

import { COMMON_LOGIN_MODAL } from '../utils/constants';

import NotLoggedIcon from './NotLoggedIcon';
import CreateAnAccount from './CreateAnAccount';
import { MODAL_LOGIN, MODAL_SIGNUP } from './constants';

import styles from './LoginIconButton.module.scss';

const handleLoginClick = (action, actionText) => {
  Mediator.publish(COMMON_LOGIN_MODAL, {
    initialAction: action,
    events: {
      open: {
        eventCategory: 'signup/login modal',
        eventAction: `${actionText} button`,
        eventLabel: 'open'
      },
      close: {
        eventCategory: 'signup/login modal',
        eventAction: 'Signup/Login button',
        eventLabel: 'close'
      }
    }
  });
};

const NotLoggedIconButton = () => {
  return (
    <Dropdown
      title={
        <div className={styles['login-icon-button']}>
          <NotLoggedIcon />
        </div>
      }
      position="right"
      color="light"
      itemsColor="light-redesign"
      dataTest="non-logged-in-menu"
      disableHover
      roundedBorders
      className="menu-white-redesign"
    >
      <DropdownItem className={styles['login-icon-button__top-block']}>
        <span>{trans('login.welcome')}</span>
      </DropdownItem>

      <DropdownSeparator />

      <DropdownItem>
        <div>
          <SupportCenter
            backgroundColor="blue"
            photo="whiteShort"
            target="support"
            className={styles['login-icon-button__support-center']}
          />
        </div>
      </DropdownItem>

      <DropdownSeparator />

      <DropdownItem inline>
        <a href={getPagePath('marketplace.favorites')}>
          <DSIcon name="fav_line" /> {trans('favorites.title.favorites')}
        </a>
      </DropdownItem>
      <DropdownItem inline>
        <a href={getPagePath('externals.help-center')}>
          <DSIcon name="help_circle" />
          {trans('menu.support-center.help-guide')}
        </a>
      </DropdownItem>
      <DropdownItem inline>
        <a href={getPagePath('refer-a-friend')}>
          <DSIcon name="diamond" /> {trans('my-referrals.cta.revamp')}
        </a>
      </DropdownItem>

      <DropdownSeparator />

      <DropdownItem>
        <HeaderLink
          onClick={() => handleLoginClick(MODAL_SIGNUP, 'Signup')}
          data-test="signup-header-link"
          className="ga-signup-menu-button"
        >
          <CreateAnAccount />
        </HeaderLink>
      </DropdownItem>

      <DropdownSeparator />

      <DropdownItem>
        <HeaderLink
          onClick={() => handleLoginClick(MODAL_LOGIN, 'Login')}
          data-test="login-header-link"
          className="ga-login-menu-button"
        >
          {trans('login.text')}
        </HeaderLink>
      </DropdownItem>
    </Dropdown>
  );
};

export default NotLoggedIconButton;
